import { Card, Col, Empty, Skeleton } from 'antd';
import { arrowLeft, iconPhoto } from 'assets';
import { Button, GridImageGraft, Modal } from 'components';
import { useAppDispatch } from 'hooks';
import html2canvas from 'html2canvas';
import { getAlbumsImage } from 'pages/SiteDetail/thunk';
import React, { createRef, FC, useCallback, useEffect, useState } from 'react';
import Draggable from 'react-draggable';
import 'react-image-crop/dist/ReactCrop.css';
// 2023/04/26 Leading Win WEB側写真合成の工種の選択肢不正対応 start
// import { GetDetailImageResponse, GetWorkerType, ImageAlbum } from 'types';
import { GetDetailImageResponse, GetPerformanceWorkerType, ImageAlbum } from 'types';
// 2023/04/26 Leading Win WEB側写真合成の工種の選択肢不正対応 end
import { FormikProvider, useFormik } from 'formik';
import { Form } from 'formik-antd';
import SelectField from 'components/Forms/SelectField';
import { dayjs, piexif } from 'libs';
import { addImage } from 'pages/SiteDetail/slice';
import { albumsService, siteService } from 'services';
import CardGraftDrop from './CardGraftDrop';
import { ButtonSubmit, CardGraft, DetailImageContentStyledGraft, HeaderStyled } from './styles';

interface Props {
  data?: ImageAlbum | null;
  onCancel: () => void;
  visible: boolean;
  images: ImageAlbum[];
  showModal: (open: boolean) => void;
  closeModalImage: (close: boolean) => void;
  detailImage: GetDetailImageResponse | null;
  convertImage: string;
  // 2023/04/26 Leading Win WEB側写真合成の工種の選択肢不正対応 start
  // dataWorker: GetWorkerType[];
  dataWorker: GetPerformanceWorkerType[];
  // 2023/04/26 Leading Win WEB側写真合成の工種の選択肢不正対応 end
}

interface BoxMap {
  [key: string]: { title: JSX.Element };
}

const GraftImageModal: FC<Props> = ({
  visible,
  detailImage,
  showModal,
  closeModalImage,
  images,
  dataWorker,
}) => {
  const dispatch = useAppDispatch();
  const imageRef = createRef() as React.MutableRefObject<HTMLDivElement>;
  const [convertImage, setConvertImage] = useState('');
  const [loading, setLoading] = useState<boolean>(true);

  const [positionDetail, setPositionDetail] = useState({ x: 6, y: -257 });
  const [imageCrop, setImageCrop] = useState<ImageAlbum>();
  const [boxes, setBoxes] = useState<BoxMap>({
    graft: {
      title: (
        <CardGraft>
          <Card bordered={false} style={{ width: 210 }}>
            <p className="title-name">工事名</p>
            <p className="title-id-about">工事コード</p>
            <p className="title-id-about">工種</p>
            <Empty
              className="title-id-image-empty"
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<div>"ここに写真が合成されます"</div>}
            />
          </Card>
        </CardGraft>
      ),
    },
  });

  const onPrevious = () => {
    closeModalImage(false);
    showModal(true);
  };

  const initialValues = {
    onSiteName: '',
    startDate: null,
  };
  const formik = useFormik({
    initialValues,
    async onSubmit(values) {
      if (!values.startDate) {
        formik.setFieldError('startDate', '');
      }
      formik.resetForm();
    },
  });

  const getBase64FromUrl = async (url: '' | undefined | string) => {
    try {
      if (url) {
        const data = await fetch(url);
        const blob = await data.blob();
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const base64data = reader.result;
            resolve(base64data);
          };
        });
      }
    } catch (error) {
      return null;
    }
  };
  useEffect(() => {
    setLoading(true);
    const f = async () => {
      const convertItemImage =
        detailImage?.image_url &&
        detailImage?.image_url.replace(
          process.env.REACT_APP_S3_RES_URL || '',
          process.env.REACT_APP_RES_URL || ''
        );
      const imgBase: any = await getBase64FromUrl(convertItemImage);
      setLoading(!convertItemImage);
      imgBase && setConvertImage(imgBase);
    };
    f();
  }, [detailImage]);

  const onSiteNames = dataWorker.map((value, index) => ({
    // 2023/04/26 Leading Win WEB側写真合成の工種の選択肢不正対応 start
    // label: value.work_type_name,
    label: value.major_construction_name,
    // 2023/04/26 Leading Win WEB側写真合成の工種の選択肢不正対応 end
    value: index,
  }));
  const dataSiteOnes = onSiteNames.find((value) =>
    value.value === Number(formik.values.onSiteName) ? value.label : ''
  );

  useEffect(() => {
    return () => {
      setBoxes({
        graft: {
          title: (
            <CardGraft>
              <Card bordered={false} style={{ width: 210 }}>
                <div className="title-name">
                  <Col span={9}>
                    <span>工事名</span>
                  </Col>
                  <Col span={15}>
                    <span>{detailImage?.site_name}</span>
                  </Col>
                </div>
                <div className="title-id-about">
                  <Col span={9}>
                    <span>工事コード</span>
                  </Col>
                  <Col span={15}>
                    <span>{detailImage?.building_code}</span>
                  </Col>
                </div>
                <div className="title-id-about title-id-type">
                  <Col span={9}>
                    <span>工種</span>
                  </Col>
                  <Col span={15}>
                    <span>{null}</span>
                  </Col>
                </div>
                <Empty
                  className="title-id-image-empty"
                  description="ここに写真が合成されます"
                  image={<img src={iconPhoto} alt="iconPhoto" />}
                  imageStyle={{
                    width: '22px',
                    height: '17px',
                    opacity: '0.5',
                    position: 'absolute',
                    left: '50%',
                    top: '60%',
                    transform: 'translate(-50%, -50%)',
                  }}
                />
              </Card>
            </CardGraft>
          ),
        },
      });
      setPositionDetail({ x: 6, y: -220 });
    };
  }, [detailImage, convertImage]);

  const handleClickImage = useCallback(
    async (image: ImageAlbum) => {
      setImageCrop(image);
      Object.keys(boxes).map(() => {
        return setBoxes({
          graft: {
            title: (
              <CardGraftDrop
                detailImage={detailImage}
                image={image}
                dataSite={formik.values.onSiteName === '' ? '' : dataSiteOnes?.label}
                formik={formik.values.onSiteName}
              />
            ),
          },
        });
      });
    },
    [boxes, dataSiteOnes, detailImage, formik]
  );

  const captureScreenshot = useCallback(() => {
    if (!detailImage) return;
    html2canvas(imageRef.current).then(async (canvas) => {
      const ctx = canvas.getContext('2d');
      if (ctx !== null) {
        ctx.imageSmoothingQuality = 'high';
      }
      const exif: Record<number, string> = {};
      exif[piexif.ExifIFD.DateTimeOriginal] = JSON.parse(detailImage.exif_text)?.DateTimeOriginal;
      exif[piexif.ExifIFD.DateTimeDigitized] = JSON.parse(detailImage.exif_text)?.DateTimeDigitized;

      // 2023/05/25 Leading Win Exif情報の306DateTimeのタグが含まれていない対応 start
      Object.entries(piexif.ExifIFD).map(([key, value]) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (!JSON.parse(detailImage?.exif_text)[key]) return;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        exif[value] = JSON.parse(detailImage?.exif_text)[key];
      });
      // 2023/05/25 Leading Win Exif情報の306DateTimeのタグが含まれていない対応 end
      const exif_text = JSON.stringify({
        ...JSON.parse(detailImage?.exif_text),
        DateTime: JSON.parse(detailImage?.exif_text)?.DateTime,
        DateTimeOriginal: JSON.parse(detailImage?.exif_text)?.DateTimeOriginal,
        DateTimeDigitized: JSON.parse(detailImage?.exif_text)?.DateTimeDigitized,
      });
      const gpsIfd: Record<number, any> = {};
      const lat = JSON.parse(detailImage?.exif_text)?.latitude;
      const lng = JSON.parse(detailImage?.exif_text)?.longitude;
      gpsIfd[piexif.GPSIFD.GPSLatitudeRef] = lat < 0 ? 'S' : 'N';
      gpsIfd[piexif.GPSIFD.GPSLatitude] = piexif.GPSHelper.degToDmsRationalv1(lat);
      gpsIfd[piexif.GPSIFD.GPSLongitudeRef] = lng < 0 ? 'W' : 'E';
      gpsIfd[piexif.GPSIFD.GPSLongitude] = piexif.GPSHelper.degToDmsRationalv1(lng);
      const exifObj = { Exif: exif, GPS: gpsIfd };
      const exifStr = piexif.dump(exifObj);
      const base64Image = canvas.toDataURL('image/jpeg');
      const base64 = piexif.insert(exifStr, base64Image);

      const res = await albumsService.addImages({
        building_id: `${detailImage?.building_id}`,
        exif_text,
        folder_id: `${detailImage?.folder_id}`,
        image_binary: base64,
        taken_date: `${detailImage?.taken_date}`,
        edited_date: `${dayjs()}`,
      });
      if (res?.data) {
        dispatch(addImage([res.data, ...images]));
        if (res?.data?.testing_flag === 1) {
          siteService.uploadImages({ image_id: [res.data?.image_id] });
        }
      }
      await dispatch(getAlbumsImage({ building_id: detailImage?.building_id }));
    });
    closeModalImage(false);
  }, [detailImage, imageRef, closeModalImage, images, dispatch]);

  const onCancelGraft = () => {
    closeModalImage(false);
    setBoxes({
      graft: {
        title: (
          <CardGraft>
            <Card bordered={false} style={{ width: 210 }}>
              <p className="title-name">工事名</p>
              <p className="title-id-about">工事コード</p>
              <p className="title-id-about">工種</p>
              <Empty className="title-id-image-empty" image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </Card>
          </CardGraft>
        ),
      },
    });
  };

  return (
    <Modal
      title={
        <HeaderStyled onClick={onCancelGraft}>
          <img src={arrowLeft} alt="arrowLeft" />
          <div>写真を合成</div>
        </HeaderStyled>
      }
      destroyOnClose={true}
      visible={visible}
      footer={false}
      width={1100}
    >
      <DetailImageContentStyledGraft>
        <div className="image" ref={imageRef}>
          {!loading ? (
            <img
              className="card-width-height"
              src={convertImage}
              alt="img-modal"
              draggable="false"
              style={{ width: 600, height: 450 }}
            />
          ) : (
            <Skeleton.Button active style={{ width: 600, height: 450, maxWidth: '100%' }} />
          )}
          {convertImage && (
            <Draggable
              axis="both"
              bounds={{ left: 1, top: -449, right: 389, bottom: -255 }}
              defaultPosition={positionDetail}
              handle=".handle"
            >
              <div className={`handle`} style={{ width: 'fit-content' }}>
                {Object.keys(boxes).map((key) => {
                  const { title } = boxes[key];
                  return <div>{title}</div>;
                })}
              </div>
            </Draggable>
          )}
        </div>
        <div className="info">
          <div className="title">工種を選択</div>
          <FormikProvider value={formik}>
            <Form layout="vertical" className="form">
              <div className="">
                <div className="box-select">
                  <Form.Item className="input-onsite" colon={false} name="onSiteName">
                    <SelectField
                      data={onSiteNames}
                      onChange={(e) => {
                        const dataSiteOneWorker = onSiteNames.find(
                          (value: { value: number; label: string }) =>
                            value.value === Number(e) ? value.label : ''
                        );
                        imageCrop &&
                          setBoxes({
                            graft: {
                              title: (
                                <CardGraftDrop
                                  detailImage={detailImage}
                                  image={imageCrop}
                                  dataSite={dataSiteOneWorker?.label}
                                  formik={e}
                                />
                              ),
                            },
                          });
                        !imageCrop &&
                          setBoxes({
                            graft: {
                              title: (
                                <CardGraftDrop
                                  detailImage={detailImage}
                                  image={imageCrop}
                                  dataSite={dataSiteOneWorker?.label}
                                  formik={e}
                                />
                              ),
                            },
                          });
                      }}
                      name="onSiteName"
                      className="select-field"
                      placeholder="工種を選択してください"
                    />
                  </Form.Item>
                </div>
              </div>
            </Form>
          </FormikProvider>
          <div className="title">合成する写真を選択</div>
          <div className="album-image">
            {!!images.length && (
              <GridImageGraft data={images} onClickImage={(image) => handleClickImage(image)} />
            )}
          </div>
        </div>
      </DetailImageContentStyledGraft>
      <div className="ant-modal-footer">
        <ButtonSubmit>
          <Button onClick={onPrevious}>キャンセル</Button>
          <Button
            className={`${!!imageCrop && formik.values.onSiteName !== '' ? 'button-submit' : ''}`}
            disabled={
              !imageCrop ||
              formik.values.onSiteName === formik.initialValues.onSiteName ||
              !convertImage
            }
            onClick={captureScreenshot}
          >
            保存
          </Button>
        </ButtonSubmit>
      </div>
    </Modal>
  );
};

export default GraftImageModal;
